export const COUNTRY_INDIA = [
  { state: "Andhra Pradesh", city: "Amaravati" },
  { state: "Arunachal Pradesh", city: "Itanagar" },
  { state: "Assam", city: "Dispur" },
  { state: "Bihar", city: "Patna" },
  { state: "Chhattisgarh", city: "Raipur" },
  { state: "Goa", city: "Panaji" },
  { state: "Gujarat", city: "Gandhinagar" },
  { state: "Haryana", city: "Chandigarh" },
  { state: "Himachal Pradesh", city: "Shimla" },
  { state: "Jharkhand", city: "Ranchi" },
  { state: "Karnataka", city: "Bengaluru" },
  { state: "Kerala", city: "Thiruvananthapuram" },
  { state: "Madhya Pradesh", city: "Bhopal" },
  { state: "Maharashtra", city: "Mumbai" },
  { state: "Manipur", city: "Imphal" },
  { state: "Meghalaya", city: "Shillong" },
  { state: "Mizoram", city: "Aizawl" },
  { state: "Nagaland", city: "Kohima" },
  { state: "Odisha", city: "Bhubaneswar" },
  { state: "Punjab", city: "Chandigarh" },
  { state: "Rajasthan", city: "Jaipur" },
  { state: "Sikkim", city: "Gangtok" },
  { state: "Tamil Nadu", city: "Chennai" },
  { state: "Telangana", city: "Hyderabad" },
  { state: "Tripura", city: "Agartala" },
  { state: "Uttar Pradesh", city: "Lucknow" },
  { state: "Uttarakhand", city: "Dehradun" },
  { state: "West Bengal", city: "Kolkata" },

  { state: "Andaman and Nicobar Islands", city: "Port Blair" },
  { state: "Chandigarh", city: "Chandigarh" },
  { state: "Dadra and Nagar Haveli and Daman & Diu", city: "Daman" },
  { state: "Delhi", city: "New Delhi" },
  { state: "Jammu & Kashmir", city: "Srinagar" },
  { state: "Ladakh", city: "Leh" },
  { state: "Lakshadweep", city: "Kavaratti" },
  { state: "Puducherry", city: "Puducherry" },
];
